import * as yup from 'yup';

import { FINANCE_NUMBER_PATTERN } from '@/constants/patterns';

import { TranslatorFunction } from '@/types/i18n';
import { IncomeSource, PayFrequency } from '@/types/user';

export const MAX_INCOME_DIGITS = 6;
export const MAX_SPENDING_DIGITS = 6;
export const MAX_OTHER_SOURCE_LENGTH = 80;
export const MAX_OTHER_FREQUENCY_LENGTH = 50;
export const MAX_INCOME_SOURCES = 5;

export function getIncomeAndSpendingValidationSchema(t: TranslatorFunction) {
  return yup.object().shape({
    totalMonthlyIncome: yup
      .string()
      .required(t('moreInfo.form.yourFinances.income.monthlyIncomeRequired'))
      .matches(
        FINANCE_NUMBER_PATTERN,
        t('moreInfo.form.yourFinances.income.monthlyIncomePattern'),
      )
      .max(
        MAX_INCOME_DIGITS,
        t('moreInfo.form.yourFinances.income.monthlyIncomeMaxLength', {
          value: MAX_INCOME_DIGITS,
        }),
      ),
    sourceOfIncome: yup
      .array()
      .of(yup.string().required())
      .min(1, t('moreInfo.form.yourFinances.income.incomeSourcesRequired'))
      .required(t('moreInfo.form.yourFinances.income.incomeSourcesRequired')),
    sourceOfIncomeOther: yup.string().when('sourceOfIncome', {
      is: (sources: string[]) => sources?.includes(IncomeSource.Other),
      then: schema =>
        schema
          .required(
            t('moreInfo.form.yourFinances.income.otherIncomeSourceRequired'),
          )
          .max(
            MAX_OTHER_SOURCE_LENGTH,
            t('moreInfo.form.yourFinances.income.otherIncomeSourceMaxLength', {
              value: MAX_OTHER_SOURCE_LENGTH,
            }),
          ),
      otherwise: schema => schema.optional(),
    }),
    howOftenPaid: yup
      .string()
      .required(t('moreInfo.form.yourFinances.income.payFrequencyRequired')),
    howOftenPaidOther: yup.string().when('howOftenPaid', {
      is: PayFrequency.Other,
      then: schema =>
        schema
          .required(
            t('moreInfo.form.yourFinances.income.otherPayFrequencyRequired'),
          )
          .max(
            MAX_OTHER_FREQUENCY_LENGTH,
            t('moreInfo.form.yourFinances.income.otherPayFrequencyMaxLength', {
              value: MAX_OTHER_FREQUENCY_LENGTH,
            }),
          ),
      otherwise: schema => schema.optional(),
    }),
    totalMonthlySpending: yup
      .string()
      .required(t('moreInfo.form.yourFinances.income.monthlySpendingRequired'))
      .matches(
        FINANCE_NUMBER_PATTERN,
        t('moreInfo.form.yourFinances.income.monthlySpendingPattern'),
      )
      .max(
        MAX_SPENDING_DIGITS,
        t('moreInfo.form.yourFinances.income.monthlySpendingMaxLength', {
          value: MAX_SPENDING_DIGITS,
        }),
      ),
  });
}
